module.exports = __webpack_public_path__ + "img/nbus_10p.5887d223.png";